import React from 'react';

import { IconInfoCircle, IconWorld } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button, IconButton, Tooltip, Typography } from '@cfa/react-components';

interface TranslationsHeaderProps {
  noValidTranslations: boolean;
  onTranslateAll: () => void;
}

const TranslationsHeader: React.FC<TranslationsHeaderProps> = ({
  onTranslateAll,
  noValidTranslations,
}) => {
  const { t } = useTranslation();
  return (
    <div data-testid="translations-header">
      <div className="relative mt-6 flex w-full items-center justify-between">
        <div className="flex items-center justify-center">
          <Typography fontWeight="bold" variant="h4">
            {t('TrainingPlans.manageTranslations.translateTocurrentLanguage')}
          </Typography>
        </div>
        <div className="flex flex-row items-center justify-center gap-4">
          <Tooltip
            content={t('TrainingPlans.manageTranslations.translateAllTooltip')}
            placement="left"
            showOnElementEvents={['hover']}
          >
            <IconButton aria-label="info" size="md">
              <IconInfoCircle />
            </IconButton>
          </Tooltip>
          <Button
            color="secondary"
            data-testid="TranslateAllButton"
            disabled={noValidTranslations}
            onClick={onTranslateAll}
            className="flex items-center"
          >
            <IconWorld />
            <span className="ml-3">{t('Button.translateAll')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TranslationsHeader;
